module.exports = __webpack_public_path__ + "img/instruction-step2.cb851cd1.png";